import "../../FhVisuallyHidden.css";
import { renderSlot, openBlock, createElementBlock } from "vue";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = {
  key: 1,
  class: "sr-only"
};
const _sfc_main = {
  __name: "FhVisuallyHidden",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return props.visible ? renderSlot(_ctx.$slots, "default", { key: 0 }, void 0, true) : (openBlock(), createElementBlock("span", _hoisted_1, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]));
    };
  }
};
const FhVisuallyHidden = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-ee3bf735"]]);
export {
  FhVisuallyHidden as default
};
//# sourceMappingURL=FhVisuallyHidden.mjs.map
